import {CommunicationType} from './communicationType';
import {IFlaggable} from '../../flag/interfaces/iFlaggable';
import {FlagColor} from '../../flag/data/flagColor';
import {BaseEntity} from '../../app-common/data/BaseEntity';

export class Communication extends BaseEntity<number> implements IFlaggable {
  customerId: number;
  personName: string;
  title: string;
  description: string;
  type: CommunicationType;
  outgoing: boolean;
  flagged: boolean;
  flagColor: FlagColor;
  eventDate?: Date;
}

